import React from 'react';
import PropTypes from 'prop-types';

const HighlighterIcon = ({ fill }) => (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" href="http://www.w3.org/1999/xlink">
        <desc>Created with Sketch.</desc>
        <defs>
            <path d="M0.666666667,17.3333333 L23.3333333,17.3333333 L23.3333333,21.8333333 L0.666666667,21.8333333 L0.666666667,17.3333333 Z M11.2783685,12.3802922 L10.2020564,13.4566043 L7.49387276,11.8891776 L9.13847853,10.2404022 L11.2783685,12.3802922 Z M15.5502134,0.324116139 L21.2101459,5.98404866 L16.9336937,10.2605009 L11.2737612,4.60056838 L15.5502134,0.324116139 Z" id="hl-path-1" />
            <path d="M14.4067853,8.99817707 L18.698376,13.3006485 L13.3051046,16.4221347 L10.158348,13.2753781 L7.31345508,13.752536 C6.88674615,13.8241055 6.27438308,13.6340539 5.96511695,13.3247878 L1.12868884,8.48835965 L2.5429024,7.07414608 L6.81935464,11.3505983 L12.4792872,5.6906658 L8.20283493,1.41421356 L9.61704849,0 L14.26389,4.64684151 L14.4503983,4.83950638 C14.7506198,5.13972782 14.9511739,5.75244406 14.8781466,6.18784451 L14.4067853,8.99817707 Z M12.4746798,13.4703896 L13.5509919,14.5467017 L16.2591756,12.979275 L14.6145698,11.3304996 L12.4746798,13.4703896 Z M0.419714994,18.4234308 L23.0863817,18.4234308 L23.0863817,22.9234308 L0.419714994,22.9234308 L0.419714994,18.4234308 Z M1.41971499,19.4234308 L1.41971499,21.9234308 L22.0863817,21.9234308 L22.0863817,19.4234308 L1.41971499,19.4234308 Z" id="hl-path-3" />
        </defs>
        <g id="icon-color-highlight" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Icons-/-Custom-/-Color-Highlight" transform="translate(-4.000000, -4.000000)">
                <g id="color-highlight" transform="translate(3.753048, 4.909903)">
                    <g id="hl-icon-colors" transform="translate(0.246952, 1.090097)">
                        <mask id="hl-mask-2" fill="white">
                            <use href="#hl-path-1" />
                        </mask>
                        <use id="Mask-hl" fill="#F6637A" href="#hl-path-1" />
                        <g data-test-id="highlighter-icon-group" id="Colour-/-color-nav-yellow" mask="url(#hl-mask-2)" fill={fill || '#fff'} fillRule="nonzero">
                            <g transform="translate(-4.000000, -6.000000)" id="base_color">
                                <rect x="0" y="0" width="32" height="32" />
                            </g>
                        </g>
                    </g>
                    <g id="icon-outline" transform="translate(12.000000, 11.500000) scale(-1, 1) translate(-12.000000, -11.500000) ">
                        <mask id="hl-mask-4" fill="white">
                            <use href="#hl-path-3" />
                        </mask>
                        <use id="Mask-hl" fill="#727273" fillRule="nonzero" href="#hl-path-3" />
                        <g id="Colour-/-color-gray-700-Subtitles" mask="url(#hl-mask-4)" fill="#727273" fillRule="nonzero">
                            <g transform="translate(-4.000000, -5.000000)" id="base_color">
                                <rect x="0" y="0" width="32" height="32" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

HighlighterIcon.propTypes = {
    fill: PropTypes.string,
};

HighlighterIcon.defaultProps = {
    fill: '#FFFFFF',
};

export default HighlighterIcon;
